<template>
	<div
		class="flex-column justify-center full-height"
	>
		<div
			class="pa-10"
		>
			<div class="text-center size-px-24 font-weight-bold">
				<img :src="require('../../assets/images/logo.png')" :title="title" class="object-cover"/>
			</div>

			<div
				v-if="user_link || login_type == 'tell'"
				class="mt-50"
			>
				<div class="">
					<div class="">
						<input
							v-model="item.member_name"
							class="box width-100 pa-10  font-weight-bold"
							:class="{  input: isIdInput, 'error-underline': error.type == 'id' }"
							type="text" placeholder="이름을 입력하세요"
							maxlength="25"
							@keyup.enter="postSms"
						/>
					</div>
					<div class="mt-10 toggle-password">
						<input
							v-model="item.member_tell"
							class="box width-100 pa-10 "
							:class="{ input: isPwInput, 'error-underline': error.type == 'pw'  }"
							placeholder="휴대폰 번호를 입력하세요"
							maxlength="50"
							@keyup.enter="postSms"
						/>
					</div>
					<div
						v-if="is_on_sms"
						class=""
					>
						<input
							v-model="item.sms_code"
							class="box width-100 pa-10  font-weight-bold mt-10"
							:class="{  input: isIdInput, 'error-underline': error.type == 'id' }"
							type="text" placeholder="인증번호를 입력하세요"
							maxlength="25"
							@keyup.enter="postSms"
						/>
					</div>
					<div
						v-show="error.type"
						class="pa-10 color-red"
					><v-icon small class="color-red">mdi-alert</v-icon> {{ error.msg }}</div>
				</div>

				<div class="mt-10">
					<button
						class="btn btn-l btn-primary width-100"
						@click="postSms"
					>로그인</button>
					<div class="text-right mt-10 size-px-16 font-weight-bold"><button @click="login_type = 'id'">아이디로 로그인</button></div>
				</div>
			</div>
			<div
				v-else
				class="mt-50"
			>
				<div class="">
					<div class="">
						<input
							v-model="item.member_id"
							class="box width-100 pa-10  font-weight-bold"
							:class="{  input: isIdInput, 'error-underline': error.type == 'id' }"
							type="text" placeholder="아이디를 입력하세요."
							maxlength="25"
							@keyup.enter="login"
						/>
					</div>
					<div class="mt-10 toggle-password">
						<input
							v-model="item.member_pw"
							class="box width-100 pa-10 "
							:class="{ input: isPwInput, 'error-underline': error.type == 'pw'  }"
							:type="toggleType"
							placeholder="비밀번호를 입력하세요."
							maxlength="50"
							@keyup.enter="login"
						/>
					</div>
					<div
						v-show="error.type"
						class="pa-10 color-red"
					><v-icon small class="color-red">mdi-alert</v-icon> {{ error.msg }}</div>
				</div>

				<div class="mt-10">
					<button
						class="btn btn-l btn-primary width-100"
						@click="login"
					>로그인</button>
				</div>
				<div class="text-right mt-10 size-px-16 font-weight-bold"><button @click="login_type = 'tell'">휴대폰번호 로그인</button></div>
			</div>

			<hr v-if="false" class="under-line mt-30" />

			<div
				v-if="false"
				class="mt-30 text-center justify-center gap-50 font-weight-bold"
			>
				<button
					class="btn btn-outline btn-s"
					@click="toId"
				>아이디 찾기</button>
				<button
					class="btn btn-outline btn-s"
					@click="toPw"
				>비밀번호 찾기</button>
			</div>

		</div>
	</div>
</template>

<script>

import { Base64 } from 'js-base64'

export default{
	name: 'Login'
	,props: ['user', 'codes']
	,data: function() {
		return {
			program: {
				name: '로그인'
				, code: 'login'
				, not_top: true
				, bottom: false
				, title: false
				, bland: false
				, wrap: 'loginNew'
				, is_container: true
				, top_line: true
			}
			,item: {
				member_id: ''
				,member_pw: ''
				, type: 'login'
				, sms_code: ''
			}
			,is_id_save: false
			,is_auto_login: false
			,error: {
				type: ''
				,msg: ''
			}
			,is_id_error: false
			,is_pw_error: false
			,is_on_pw: false
			, title: process.env.VUE_APP_TITLE
			, user_link: this.$route.params.link
			, login_type: 'tell'
			, is_on_sms: false
			, is_on_sms_confirm: false
		}
	}
	,computed: {
		isIdInput: function(){
			if(this.item.member_id){
				return true
			}else{
				return false
			}
		}
		, isPwInput: function(){
			if(this.item.member_pw){
				return true
			}else{
				return false
			}
		}
		,toggleType: function(){
			if(this.is_on_pw){
				return 'text'
			}else{
				return 'password'
			}
		}
	}
	,methods: {
		login: async function(){
			let item = this.item
			try {
				const result = await this.$request.init({
					method: 'post'
					, url: '/memberProcess/login'
					, data: item
				})

				if (result.success) {

					sessionStorage.setItem(Base64.encode(process.env.VUE_APP_NAME + 'AT'), Base64.encode(result.data.token))
					// sessionStorage.setItem(process.env.VUE_APP_NAME + 'T', Base64.encode(this.item.member_id))
					// sessionStorage.setItem(process.env.VUE_APP_NAME + 'T2', Base64.encode(this.item.member_pw))

					if (this.is_id_save) {
						localStorage.setItem(process.env.VUE_APP_NAME + 'S', Base64.encode(this.item.member_id))
					} else {
						localStorage.removeItem(process.env.VUE_APP_NAME + 'S')
						//localStorage.removeItem('is_id_save')
					}
					if (this.is_auto_login) {
						// localStorage.setItem(process.env.VUE_APP_NAME + 'A', true)
						// localStorage.setItem(process.env.VUE_APP_NAME + 'N', Base64.encode(Base64.encode(this.item.member_id)))
						// localStorage.setItem(process.env.VUE_APP_NAME + 'P', Base64.encode(Base64.encode(this.item.member_pw)))
					} else {
						localStorage.removeItem(process.env.VUE_APP_NAME + 'A')
						if(!this.is_id_save) {
							localStorage.removeItem(process.env.VUE_APP_NAME + 'N')
						}
						localStorage.removeItem(process.env.VUE_APP_NAME + 'P')
					}
					this.toMain()
					this.error.type = ''
				} else {

					if(result.message.indexOf('아이디') > -1){
						this.error.type = 'id'
					}else{
						this.error.type = 'pw'
					}
					this.error.msg = result.message
				}
			} catch (E) {
				console.log(E)
				this.$bus.$emit('notify', {type: 'error', message: E})
			}
		}
		,toggles_on_pw: function(){
			if(this.is_on_pw){
				this.is_on_pw = false
			}else{
				this.is_on_pw = true
			}
		}
		,toMain: function(){
			document.location.href = process.env.VUE_APP_PUBLIC_PATH + 'Index'
		}
		, toId: function(){
			this.$bus.$emit('to', { name: 'FindId'})
		}
		, toPw: function(){
			this.$bus.$emit('to', { name: 'FindPw'})
		}
		, toJoin: function(){
			this.$bus.$emit('to', { name: 'Join'})
		}
		, login2: async function(){

			try {
				const result = await this.$request.init({
					method: 'post'
					, url: '/memberProcess/projectLogin'
					, data: {
						idx: this.$route.params.idx
						, member_name: this.item.member_name
						, member_tell: this.item.member_tell
						, sms_code: this.item.sms_code
						, type: this.item.type
					}
				})

				if (result.success) {

					sessionStorage.setItem(Base64.encode(process.env.VUE_APP_NAME + 'AT'), Base64.encode(result.data.token))
					// sessionStorage.setItem(process.env.VUE_APP_NAME + 'T', Base64.encode(this.item.member_id))
					// sessionStorage.setItem(process.env.VUE_APP_NAME + 'T2', Base64.encode(this.item.member_pw))

					if (this.is_id_save) {
						localStorage.setItem(process.env.VUE_APP_NAME + 'S', Base64.encode(this.item.member_id))
					} else {
						localStorage.removeItem(process.env.VUE_APP_NAME + 'S')
						//localStorage.removeItem('is_id_save')
					}
					if (this.is_auto_login) {
						// localStorage.setItem(process.env.VUE_APP_NAME + 'A', true)
						// localStorage.setItem(process.env.VUE_APP_NAME + 'N', Base64.encode(Base64.encode(this.item.member_id)))
						// localStorage.setItem(process.env.VUE_APP_NAME + 'P', Base64.encode(Base64.encode(this.item.member_pw)))
					} else {
						localStorage.removeItem(process.env.VUE_APP_NAME + 'A')
						if(!this.is_id_save) {
							localStorage.removeItem(process.env.VUE_APP_NAME + 'N')
						}
						localStorage.removeItem(process.env.VUE_APP_NAME + 'P')
					}
					this.toMain()
					this.error.type = ''
				} else {

					if(result.message.indexOf('아이디') > -1){
						this.error.type = 'id'
					}else{
						this.error.type = 'pw'
					}
					this.error.msg = result.message
				}
			} catch (E) {
				console.log(E)
				this.$bus.$emit('notify', {type: 'error', message: E})
			}
		}
		, postSms: async function(){

			if(this.is_on_sms){
				await this.login2()
			}else{

				try{
					const result = await this.$request.init({
						method: 'post'
						, url: 'auth/postSmsAuth'
						, data: this.item
					})

					if(result.success){
						this.is_on_sms = true
					}else{
						this.$bus.$emit('notify', { type: 'error', message: result.message })
					}
				}catch(E){
					console.log(E)
					this.$bus.$emit('notify', { type: 'error', message: E })
				}
			}
		}
	}
	,mounted() {
		if(localStorage.getItem(process.env.VUE_APP_NAME + 'S')){
			this.is_id_save = Base64.decode(localStorage.getItem(process.env.VUE_APP_NAME + 'S'))
			this.item.member_id = Base64.decode(localStorage.getItem(process.env.VUE_APP_NAME + 'S'))
		}

		if(localStorage.getItem(process.env.VUE_APP_NAME + 'A')){
			this.is_auto_login = Base64.decode(localStorage.getItem(process.env.VUE_APP_NAME + 'A'))
			this.item.member_id = Base64.decode(Base64.decode(localStorage.getItem(process.env.VUE_APP_NAME + 'N')))
			this.item.member_pw = Base64.decode(Base64.decode(localStorage.getItem(process.env.VUE_APP_NAME + 'P')))
			this.login()
		}
	}
	,created: function(){
		this.$bus.$emit('onLoad', this.program)
		if(this.user.member_id){
			this.toMain()
		}

		console.log('login', this.user)
	}
	,watch: {
		user:{
			handler(call){
				if(call.member_id){
					this.toMain()
				}
			}
		}
	}
}
</script>

<style>

</style>